"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var UkMoneyBagLined = function UkMoneyBagLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.735 7.934A.494.494 0 0016 7.5a.5.5 0 00-.5-.5h-.191l1.638-3.276a.5.5 0 00-.069-.551.506.506 0 00-.536-.148 4.148 4.148 0 01-3.59-.372A5.055 5.055 0 0010.5 2a4.875 4.875 0 00-3.354 1.146.5.5 0 00-.093.578L8.691 7H8.5a.5.5 0 00-.5.5.494.494 0 00.265.434C6.771 9.369 4 12.5 4 16a8 8 0 001.863 5.121A2.482 2.482 0 007.774 22h8.452a2.482 2.482 0 001.911-.879A8 8 0 0020 16c0-3.5-2.771-6.631-4.265-8.066zM10.5 3a4.162 4.162 0 011.822.556 5.212 5.212 0 003.252.678L14.191 7H9.809L8.13 3.642A4.268 4.268 0 0110.5 3zm6.87 17.479a1.484 1.484 0 01-1.144.521H7.774a1.484 1.484 0 01-1.144-.521A6.99 6.99 0 015 16c0-3.808 3.91-7.34 4.682-8h4.637C15.09 8.658 19 12.186 19 16a6.99 6.99 0 01-1.63 4.479zM15 18.5a.5.5 0 01-.5.5H9.7a.5.5 0 010-1c.338 0 1.3-.367 1.3-2v-1h-.5a.5.5 0 010-1h.5v-1.75A2.086 2.086 0 0113.05 10a2.245 2.245 0 011.724.8.5.5 0 11-.766.642A1.248 1.248 0 0013.05 11 1.109 1.109 0 0012 12.25V14h1.88a.5.5 0 110 1H12v1a3.437 3.437 0 01-.553 2H14.5a.5.5 0 01.5.5z",
    fill: "currentColor"
  })));
};

var _default = UkMoneyBagLined;
exports["default"] = _default;